import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'A loja é física?',
      answer: 'Sim! Estamos no coração de São Paulo, na Rua Aurora, 200 (Lojas 103/105), Santa Ifigênia. Pode vir retirar pessoalmente e conhecer nosso showroom completo!'
    },
    {
      question: 'Os produtos têm garantia?',
      answer: 'Com certeza. Todos os nossos consoles e acessórios possuem garantia oficial do fabricante e suporte total da loja. Você compra com total segurança e tranquilidade.'
    },
    {
      question: 'Vocês aceitam trocas?',
      answer: 'Sim! Avaliamos seu console ou jogo usado como parte do pagamento na compra de um novo. Consulte as condições e valores através do nosso WhatsApp.'
    },
    {
      question: 'Enviam para todo o Brasil?',
      answer: 'Sim, enviamos com segurança e embalagem reforçada para qualquer estado do Brasil. Seu item chega perfeito na sua casa com rastreamento completo.'
    },
    {
      question: 'Quais são as formas de pagamento?',
      answer: 'Parcelamos em até 12x no cartão, aceitamos PIX com desconto especial, dinheiro e também oferecemos condições facilitadas. Consulte as melhores opções para você!'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black relative">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-[#0047AB] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Perguntas <span className="text-[#0047AB]">Frequentes</span>
          </h2>
          <p className="text-xl text-gray-400">
            Tire suas dúvidas sobre localização, garantia, trocas, envios e pagamentos
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-900 to-black border border-[#0047AB]/30 rounded-xl overflow-hidden hover:border-[#0047AB] transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer group"
              >
                <h4 className="text-lg font-bold text-white pr-4 group-hover:text-[#0047AB] transition-colors duration-300">
                  {faq.question}
                </h4>
                <div className="w-10 h-10 bg-[#0047AB]/20 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-[#0047AB]/30 transition-colors duration-300">
                  <i className={`${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'} text-xl text-[#0047AB]`}></i>
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="px-6 pb-5">
                  <p className="text-gray-400 leading-relaxed border-t border-[#0047AB]/20 pt-4">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-gradient-to-br from-[#0047AB]/10 to-transparent border border-[#0047AB]/30 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-white mb-3">Ainda tem dúvidas?</h3>
          <p className="text-gray-400 mb-6">Nossa equipe está pronta para te atender no WhatsApp</p>
          <a 
            href="https://wa.me/5511951063038" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-[#0047AB] text-white px-8 py-4 rounded-lg hover:bg-[#003380] transition-all duration-300 text-lg font-bold cursor-pointer shadow-xl shadow-[#0047AB]/40 hover:shadow-[#0047AB]/60 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-question-answer-line mr-2"></i>
            Falar com Especialista
          </a>
        </div>
      </div>
    </section>
  );
}